var React = require('react');

function Holidays (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.127 14.56L14.557 13.13L20.997 19.573L19.57 21L13.127 14.56ZM17.42 8.83001L20.28 5.97001C16.33 2.02001 9.92998 2.01001 5.97998 5.95001C9.90998 4.65001 14.29 5.70001 17.42 8.83001ZM5.94998 5.98001C2.00998 9.93001 2.01998 16.33 5.96998 20.28L8.82998 17.42C5.69998 14.29 4.64998 9.91001 5.94998 5.98001ZM5.96998 5.96001L5.95998 5.97001C5.57998 8.98001 7.12998 12.85 10.26 15.99L15.99 10.26C12.86 7.13001 8.97998 5.58001 5.96998 5.96001Z","fill":"#323232"}));
}

Holidays.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Holidays;

Holidays.default = Holidays;
